import React from 'react';

const Portfolio = () => {
return (
<>
  <section
    className="success-stories  portfolio-main bg-250147"
    style={{ backgroundImage: "url(assets/img/portfolio-bg.png)" }}
  >
    <i className="glow-3" />
    <div className="container-lg inner-container position-relative text-white text-center">
      <h1>Portfolio</h1>
      <div className="row justify-content-center">
        <div className="col-lg-10 px-lg-4">
          <p>
            The B2B buying process is becoming more social. The buying of
            products or services is a group decision, and buyers are constantly
            sharing seller stories, reviewing experiences, and examining risk
            factors.
          </p>
          <p>
            Purplepatch helps you tell brilliant stories. Of your products
            delivering disruptive benefits. Of your services helping transform
            your customers’ business processes. We craft your stories that
            communicate, convince, and build context for your business growth.
          </p>
          <p>
            Here are some clients who continue to win in the market by telling
            brilliant stories and shortening their sales cycles.
          </p>
        </div>
      </div>
    </div>
  </section>
  <section className="success-stories-list">
    <div className="container-lg inner-container position-relative">
      <div className="row suc-rw">
        {/* loop*/}
        <div className="col-lg-4 col-sm-6">
          <div className="case-boxx d-flex text-center">
            <div className="coo">
              <a href="#" className="site-links" target="_blank" title="#" />
              <div className="iim-sec">
                <img src="assets/img/clients-1/accellor-3.svg" alt="Accellor" />
              </div>
            </div>
          </div>
        </div>
        {/* loop End*/}
        <div className="col-lg-4 col-sm-6">
          <div className="case-boxx d-flex text-center">
            <div className="coo">
              <a href="#" className="site-links" target="_blank" title="#" />
              <div className="iim-sec">
                <img src="assets/img/clients-1/beeline.svg" alt="beeline" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section
    className="get-form-touch"
    style={{ backgroundImage: "url(assets/img/get-form-touch.png)" }}
  >
    <div className="container-lg inner-container">
      <div className="row">
        <div className="col-md-6 text-white">
          <h5 className="ss-1">Contact</h5>
          <h4 className="ss-2">
            Ready to start your growth with Our B2B Digital Marketing Service?
          </h4>
          <div className="home-feat-article">
            <div className="dflex-1 text-black">
              <div className="dflex-1-cnt">
                <h6>Featured Article</h6>
                <h5>What is good conversion rate?</h5>
              </div>
              <div className="dflex-1-icon">
                <img src="assets/img/peop-1.png" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6 text-white">
          <h6 className="ss-3">
            Your success story begins here. Connect with us today!
          </h6>
          <p>
            Are you ready to start elevating your brand and getting results?
            Then stop reading and start typing! Fill out the form and let’s
            begin…
          </p>
        </div>
      </div>
    </div>
  </section>
</>

  );
};

export default Portfolio;